import { render, staticRenderFns } from "./ProfPic.vue?vue&type=template&id=6c02ff79&"
import script from "./ProfPic.vue?vue&type=script&lang=js&"
export * from "./ProfPic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports